import React from 'react';

// `size` controls the modal's max width — "sm" (default) fits a short
// confirm dialog or a handful of fields; "lg" gives a longer form (several
// fields, or dynamic rows like criteria) more breathing room instead of
// squeezing everything into the same narrow column.
const SIZE_CLASSES = {
  sm: 'max-w-sm',
  lg: 'max-w-xl',
};

export default function ConfirmModal({
  open,
  title,
  children,
  confirmLabel = 'Confirm',
  onConfirm,
  onCancel,
  footer,
  size = 'sm',
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-ink/30 backdrop-blur-[1px] px-4">
      <div className={`w-full ${SIZE_CLASSES[size] || SIZE_CLASSES.sm} bg-card border border-border rounded-2xl shadow-lg p-6`}>
        <h2 className="text-lg font-semibold text-ink">{title}</h2>
        <div className="mt-3 text-sm text-ink">{children}</div>

        {footer ? (
          <div className="mt-6">{footer}</div>
        ) : (
          <div className="mt-6 flex gap-3">
            <button
              onClick={onCancel}
              className="flex-1 py-2.5 rounded-xl font-medium border border-border text-ink hover:bg-card-tint transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 py-2.5 rounded-xl font-semibold text-white bg-gold hover:bg-bronze transition-colors"
            >
              {confirmLabel}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
